import { useEffect, useState } from 'react';

import Layout from '../../layout/Dashboard';

import * as Styles from './CompanyWithoutLogin.styles';

export default function CompanyWithoutLogin() {
  const [company, setCompany] = useState({
    stockName: '--',
    stock: '--',
  });

  useEffect(() => {
    const stockName = document.getElementById('stockName')?.value;
    const stock = document.getElementById('stock')?.value;
    if (stock) {
      setCompany({
        stockName,
        stock,
      });
    }
  }, []);
  return (
    <Layout>
      <div className="w-full min-h-full flex justify-center items-center py-4">
        <div>
          <Styles.Banner className="flex justify-center">
            <div className="text-center stockup-ai-main-content overflow-hidden rounded-3xl mx-auto">
              <div className="stockup-ai-header--name">
                StockUp <span>AI</span>
              </div>
              <div className="stockup-ai-header--title !mt-8">Công cụ AI độc quyền dành cho nhà đầu tư chứng khoán.</div>
              <ul className="stockup-ai-feature flex justify-center gap-7 mt-3">
                <li className="flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none" className="icon">
                    <path d="M25.612 8.73353C25.0448 8.16626 24.1284 8.16626 23.5612 8.73353L15.3576 16.9371L17.4085 18.9879L25.612 10.7699C26.1648 10.2171 26.1648 9.28625 25.612 8.73353ZM31.7792 8.71898L17.4085 23.0897L12.3468 18.0425C11.7795 17.4752 10.8631 17.4752 10.2959 18.0425C9.7286 18.6098 9.7286 19.5261 10.2959 20.0934L16.3758 26.1733C16.9431 26.7406 17.8594 26.7406 18.4267 26.1733L33.8301 10.7844C34.3974 10.2171 34.3974 9.3008 33.8301 8.73353H33.8156C33.2628 8.15172 32.3465 8.15172 31.7792 8.71898ZM2.07779 20.1079L8.15772 26.1878C8.72498 26.7551 9.64133 26.7551 10.2086 26.1878L11.2268 25.1697L4.12868 18.0425C3.56141 17.4752 2.64506 17.4752 2.07779 18.0425C1.51053 18.6098 1.51053 19.5407 2.07779 20.1079Z" fill="#F0D60B"/>
                  </svg>
                  <span className="capitalize ml-1 whitespace-nowrap">Kiến thức đầu tư</span>
                </li>
                <li className="flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none" className="icon">
                    <path d="M25.612 8.73353C25.0448 8.16626 24.1284 8.16626 23.5612 8.73353L15.3576 16.9371L17.4085 18.9879L25.612 10.7699C26.1648 10.2171 26.1648 9.28625 25.612 8.73353ZM31.7792 8.71898L17.4085 23.0897L12.3468 18.0425C11.7795 17.4752 10.8631 17.4752 10.2959 18.0425C9.7286 18.6098 9.7286 19.5261 10.2959 20.0934L16.3758 26.1733C16.9431 26.7406 17.8594 26.7406 18.4267 26.1733L33.8301 10.7844C34.3974 10.2171 34.3974 9.3008 33.8301 8.73353H33.8156C33.2628 8.15172 32.3465 8.15172 31.7792 8.71898ZM2.07779 20.1079L8.15772 26.1878C8.72498 26.7551 9.64133 26.7551 10.2086 26.1878L11.2268 25.1697L4.12868 18.0425C3.56141 17.4752 2.64506 17.4752 2.07779 18.0425C1.51053 18.6098 1.51053 19.5407 2.07779 20.1079Z" fill="#F0D60B"/>
                  </svg>
                  <span className="capitalize ml-1 whitespace-nowrap">Tin tức thị trường</span>
                </li>
                <li className="flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none" className="icon">
                    <path d="M25.612 8.73353C25.0448 8.16626 24.1284 8.16626 23.5612 8.73353L15.3576 16.9371L17.4085 18.9879L25.612 10.7699C26.1648 10.2171 26.1648 9.28625 25.612 8.73353ZM31.7792 8.71898L17.4085 23.0897L12.3468 18.0425C11.7795 17.4752 10.8631 17.4752 10.2959 18.0425C9.7286 18.6098 9.7286 19.5261 10.2959 20.0934L16.3758 26.1733C16.9431 26.7406 17.8594 26.7406 18.4267 26.1733L33.8301 10.7844C34.3974 10.2171 34.3974 9.3008 33.8301 8.73353H33.8156C33.2628 8.15172 32.3465 8.15172 31.7792 8.71898ZM2.07779 20.1079L8.15772 26.1878C8.72498 26.7551 9.64133 26.7551 10.2086 26.1878L11.2268 25.1697L4.12868 18.0425C3.56141 17.4752 2.64506 17.4752 2.07779 18.0425C1.51053 18.6098 1.51053 19.5407 2.07779 20.1079Z" fill="#F0D60B"/>
                  </svg>
                  <span className="capitalize ml-1 whitespace-nowrap">phân tích đầu tư</span>
                </li>
                <li className="flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none" className="icon">
                    <path d="M25.612 8.73353C25.0448 8.16626 24.1284 8.16626 23.5612 8.73353L15.3576 16.9371L17.4085 18.9879L25.612 10.7699C26.1648 10.2171 26.1648 9.28625 25.612 8.73353ZM31.7792 8.71898L17.4085 23.0897L12.3468 18.0425C11.7795 17.4752 10.8631 17.4752 10.2959 18.0425C9.7286 18.6098 9.7286 19.5261 10.2959 20.0934L16.3758 26.1733C16.9431 26.7406 17.8594 26.7406 18.4267 26.1733L33.8301 10.7844C34.3974 10.2171 34.3974 9.3008 33.8301 8.73353H33.8156C33.2628 8.15172 32.3465 8.15172 31.7792 8.71898ZM2.07779 20.1079L8.15772 26.1878C8.72498 26.7551 9.64133 26.7551 10.2086 26.1878L11.2268 25.1697L4.12868 18.0425C3.56141 17.4752 2.64506 17.4752 2.07779 18.0425C1.51053 18.6098 1.51053 19.5407 2.07779 20.1079Z" fill="#F0D60B"/>
                  </svg>
                  <span className="capitalize ml-1 whitespace-nowrap">Quản lý rủi ro</span>
                </li>
              </ul>
              <div className="stockup-ai-register mt-12">
                <div className="stockup-ai-register--title">Dùng thử miễn phí. Chỉ trả tiền khi thấy hữu ích.</div>
              </div>
            </div>
          </Styles.Banner>
          <Styles.MainContent className="w-full flex justify-center items-center">
            <div className="text-center">
              <h1 className="mb-2 text-2xl font-bold">
                {company?.stockName ? `${company?.stockName} - ` : ''}Mã chứng
                khoán {company?.stock}
              </h1>
              <p>
                Vui lòng đăng nhập hoặc đăng ký để xem thông tin công ty, tin
                tức liên quan, kết quả kinh doanh...
              </p>
              <div className="mt-1">
                <a
                  href="/login"
                  className="inline-block w-auto px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple mr-4 whitespace-nowrap link-login-detail-page"
                >
                  Đăng Nhập
                </a>
                <a
                  href="/signup"
                  className="text-sm underline transition ease-in-out duration-200 text-primary-main whitespace-nowrap font-medium link-register-detail-page"
                >
                  Đăng Ký Tài Khoản
                </a>
              </div>
            </div>
          </Styles.MainContent>
        </div>
      </div>
    </Layout>
  );
}
